export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.4-1339.15",
  commitId: "9f81dfc518172615363f927d8a4b0991a5029686",
  commitTime: "2026-08-04T13:39:15.000Z",
});
